import { Input } from "@/components/ui/input";
import { ReactQueryErrorWrapper } from "components/shared/react-query-error-wrapper";
import * as QueryKeys from "data";
import { DatasetDefinitions } from "data/models";
import { fetchDefinitions } from "data/queries-common";
import { searchCatalogue } from "content/catalogue";
import { useState } from "react";
import { UseQueryResult, useQuery } from "@tanstack/react-query";
import * as Routes from "routes";
import { CatalogueCard } from "./catalogue-card";
import { StandardPageLayout } from "@/components/layouts/standard-page-layout";
import { BookOpen } from "lucide-react";

export const CataloguePage = () => {
  const [query, setQuery] = useState("");

  // Release dates are fetched from DATAPI dynamically
  const datasetDefinitions: UseQueryResult<DatasetDefinitions> = useQuery({
    queryKey: [QueryKeys.definitionsKey],
    queryFn: () => fetchDefinitions(),
  });

  const entries = searchCatalogue(query);

  return (
    <StandardPageLayout
      pageTitle={{
        icon: BookOpen,
        title: "Data Catalogue",
        description:
          "Explore the Geoscape datasets and find the right data for your needs",
      }}
    >
      <div className="space-y-1">
        <Input
          id="query"
          name="query"
          type="text"
          placeholder="Search datasets..."
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
        <p className="text-xs text-muted-foreground">
          Search for keywords to narrow the list of data products
        </p>
      </div>

      <ReactQueryErrorWrapper queries={[datasetDefinitions]} mutations={[]} />

      {entries.length === 0 && (
        <p className="text-sm text-muted-foreground">
          No datasets match “{query}”.
        </p>
      )}

      <div className="grid gap-4 xl:grid-cols-2">
        {entries.map((entry) => (
          <CatalogueCard
            key={entry.slug}
            entry={entry}
            updatedDate={
              datasetDefinitions.data?.metadata[entry.datasetProductCode]
                ?.latestRelease
            }
          />
        ))}
      </div>
    </StandardPageLayout>
  );
};

export const viewDatasetInExplorer = (
  datasetProductCode: string,
  history: any,
) => {
  sessionStorage.setItem("catalogueToExplorer", datasetProductCode);
  history.push(Routes.dataExplorer);
};
